// extracted by mini-css-extract-plugin
export default {"bgVideoWrapper":"BgRndVideo_bgVideoWrapper__ieT4H"};